import React from 'react';
import { FaArrowUp } from 'react-icons/fa';
import './SubmitInput.css';

interface SubmitInputProps {
  // Input props
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onKeyDown?: (
    e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  placeholder: string;
  disabled?: boolean;

  // Type and behavior
  inputType?: 'input' | 'textarea';
  rows?: number;

  // Submit button
  onSubmit?: () => void;
  showSubmitButton?: boolean;
  submitDisabled?: boolean;

  // Loading state
  loading?: boolean;

  // Styling
  className?: string;
  wrapperClassName?: string;
}

const SubmitInput: React.FC<SubmitInputProps> = ({
  value,
  onChange,
  onKeyDown,
  placeholder,
  disabled = false,
  inputType = 'textarea',
  rows = 1,
  onSubmit,
  showSubmitButton = true,
  submitDisabled = false,
  loading = false,
  className = '',
  wrapperClassName = '',
}) => {
  const autoResize = (element: HTMLTextAreaElement) => {
    element.style.height = 'auto';
    element.style.height = element.scrollHeight + 'px';
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onChange(e);
    if (inputType === 'textarea' && e.target instanceof HTMLTextAreaElement) {
      autoResize(e.target);
    }
  };

  const baseInputProps = {
    value,
    onChange: handleChange,
    onKeyDown,
    placeholder,
    disabled: disabled || loading,
    className: `submit-input ${className}`,
  };

  return (
    <div className={`submit-input-wrapper ${wrapperClassName}`}>
      {inputType === 'textarea' ? (
        <textarea {...baseInputProps} rows={rows} />
      ) : (
        <input type="text" {...baseInputProps} />
      )}

      {showSubmitButton && (
        <>
          {loading ? (
            <div className="submit-loading">
              <div className="loading-spinner submit-loading-spinner"></div>
            </div>
          ) : (
            value &&
            !submitDisabled && (
              <button
                onClick={onSubmit}
                className="submit-send-button"
                disabled={loading || submitDisabled}
                type="button"
              >
                <FaArrowUp />
              </button>
            )
          )}
        </>
      )}
    </div>
  );
};

export default SubmitInput;
